import { ActionType } from "../action-types/type";

import { LanguageAction } from "../actions/index";

const initialState = { appLanguage: "en", data: {} };

export function languageReducer(state = initialState, action: LanguageAction) {
  switch (action.type) {
    case ActionType.SET_APP_LANGUAGE:
      return {
        ...state,
        appLanguage: action.payload.languageId,
        data: { ...action.payload.data },
      };
    default:
      return state;
  }
}
